import {useEffect, useState} from "react";

import {ItemRow} from "@/components/ItemRow/ItemRow.jsx";
import {App as AntdApp, Button, Dropdown} from "antd";
import api from "@/api.js";

import styles from "./ItemTable.module.css";

export const ItemTable = ({
	showCommonality,
	showAll,
	handleLoading,
	shouldSet,
	handleDownload,
	search,
	onRequestAttr,
	values,
}) => {
	const [shouldShow, setShouldShow] = useState([]);
	const [showShortDescr, setShowShortDescr] = useState(false);

	const {message} = AntdApp.useApp();

	const dropdownmenuItems = [
		{
			key: "expand",
			label: "Expand All",
			onClick: () => handleManipulation("Expand All"),
		},
		{
			key: "collapse",
			label: "Collapse All",
			onClick: () => handleManipulation("Collapse All"),
		},
	];

	function getListOfColumns() {
		const results = [
			api.get("/settings/columns?table=Search Table", { omitGlobalError: true }),
			api.get("/settings/columns?table=Description", { omitGlobalError: true }),
		];

		Promise.allSettled(results).then(([searchRes, descrRes]) => {
			if (searchRes.status === "fulfilled") {
				setShouldShow(searchRes.value.data || []);
			}

			if (descrRes.status === "fulfilled") {
				const data = descrRes.value.data;
				setShowShortDescr(data && data.length === 1 && data[0] === "short");
			} else {
				setShowShortDescr(false);
			}
		});
	}

	function handleManipulation(task) {
		if (task === "Expand All") {
			handleLoading(true, {value: true, date: new Date()});
		} else {
			handleLoading(true, {value: false, date: new Date()});
		}
	}

	function handleResultsDownload() {
		message.info("Start downloading of results", 5);
		handleDownload();
	}

	const renderRows = () => {
		return values.map((v, i) => (
			<ItemRow
				key={`${v.operator}/${v.material}`}
				index={i + 1}
				item={v}
				showShortDescr={showShortDescr}
				shouldShow={shouldShow}
				showCommonality={showCommonality}
				manipulateAll={shouldSet}
				showAll={showAll}
				onRequestAttr={onRequestAttr}
			/>
		));
	};

	useEffect(() => {
		getListOfColumns();
	}, []);

	useEffect(() => {
		handleLoading(false, null);
	}, [shouldSet]);

	if (!values || values.length === 0) return null;

	return (
		<div>
			<p>
				<strong>Search results for: </strong>
				{search}{" "}
				<Button type="link" onClick={handleResultsDownload} className={styles.buttonDownload}>
					Download search results
				</Button>
			</p>

			<table className={styles.itemsTable}>
				<thead>
					<tr>
						<th className={styles.colNumber}>#</th>
						{shouldShow.includes("source") && <th className={styles.colSource}>Source</th>}
						{shouldShow.includes("material") && <th className={styles.colMaterial}>Material</th>}
						{shouldShow.includes("cl_name") && <th className={styles.colMaterialClass}>Material class</th>}
						{shouldShow.includes("mat_type") && <th className={styles.colMaterialType}>Material Type</th>}
						{shouldShow.includes("attrs") && <th className={styles.colAttributes}>Attributes</th>}
						{shouldShow.includes("part_number") && <th className={styles.colPartNumber}>Part Number</th>}
						{shouldShow.includes("manufacturer") && <th className={styles.colManufacturer}>Manufacturer</th>}
						{shouldShow.includes("stock_level") && <th className={styles.colStock}>Stock Level</th>}
						{shouldShow.includes("score") && <th className={styles.colScore}>Score</th>}
						{<th className={styles.colFullData}>Full data</th>}
						{shouldShow.includes("commonality") && (
							<th className={styles.colCommonality}>
								{showCommonality && (
									<Dropdown menu={{items: dropdownmenuItems}}>
										<img alt="menu" src="/images/menu-horizontal.png" />
									</Dropdown>
								)}
							</th>
						)}
						{shouldShow.includes("jv") && <th className={styles.colJV}>JV</th>}

						{shouldShow.includes("image") && <th className={styles.colImage}/>}
					</tr>
				</thead>
				<tbody>{renderRows()}</tbody>
			</table>
		</div>
	);
};
